import { MonitoringState } from "./types";
export default {
  cropsYieldEvolution: (state: MonitoringState) => (uuid: string) => state.cropsYieldEvolutionContext.get(uuid) || [],
};
